import { getAuthHeader } from '.';
import { ROOT_URL } from '../utils/constants';
import type { SireAncestry } from '../models/SireAncestry';
import type { DamAncestry } from '../models/DamAncestry';

class AncestryApi {
  static async getSireAncestry(alpacaId: number) {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/sireancestry/${alpacaId}`, {
      method: 'GET',
      credentials: 'include',
      headers: headers,
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async createSireAncestry(
    alpacaId: number,
    sireAncestry: SireAncestry,
  ) {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/sireancestry/${alpacaId}`, {
      method: 'POST',
      credentials: 'include',
      headers: headers,
      body: JSON.stringify(sireAncestry),
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async updateSireAncestry(
    alpacaId: number,
    sireAncestry: SireAncestry,
  ) {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/sireancestry/${alpacaId}`, {
      method: 'PUT',
      credentials: 'include',
      headers: headers,
      body: JSON.stringify(sireAncestry),
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async deleteSireAncestry(alpacaId: number) {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/sireancestry/${alpacaId}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: headers,
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async getDamAncestry(alpacaId: number) {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/damancestry/${alpacaId}`, {
      method: 'GET',
      credentials: 'include',
      headers: headers,
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async createDamAncestry(alpacaId: number, damAncestry: DamAncestry) {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/damancestry/${alpacaId}`, {
      method: 'POST',
      credentials: 'include',
      headers: headers,
      body: JSON.stringify(damAncestry),
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async updateDamAncestry(alpacaId: number, damAncestry: DamAncestry) {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/damancestry/${alpacaId}`, {
      method: 'PUT',
      credentials: 'include',
      headers: headers,
      body: JSON.stringify(damAncestry),
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async deleteDamAncestry(alpacaId: number) {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/damancestry/${alpacaId}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: headers,
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
}

export default AncestryApi;
